import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { showSuccessMessage, showErrorMessage } from '../../notifications';
import { SERVICES, HttpMethods } from '../../../services/api';
import { fetchAccountById } from '../accounts.thunks';

export interface ContactInfoUpdateData {
  accountId: string;
  firstName: string;
  lastName: string;
  email: string;
}

export const updateAccountBillingContact: AsyncThunk<void, ContactInfoUpdateData, ThunkAPI> = createAsyncThunk(
  'accounts/updateBillingContact',
  async (data: ContactInfoUpdateData, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, ContactInfoUpdateData>({
        endpoint: `accounts/${data.accountId}`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(data, thunk);

      thunk.dispatch(showSuccessMessage('Billing contact info updated'));
      thunk.dispatch(fetchAccountById(data.accountId));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage(typeof err === 'string' ? err : 'Unknown Error'));
      return thunk.rejectWithValue(err);
    }
  }
);
